<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="backButtonEnable"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="tabsAccessControl"
    :selectedIndex="screenConfig.selectedIndex"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        :title="screenConfig.title"
        v-if="screenConfig.title"
      />
    </template>

    <div class="split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <GcDataGrid
              :grouping="true"
              :export="true"
              :summary="true"
              :dataSourceConfig="screenConfig.gridData.gridOptions.dataSource"
              :columns="screenConfig.gridData.columns"
              :gridToolbar="screenConfig.gridData.toolbar"
              :padColumn="true"
              :id="'split-view-grid'"
              :rowClick="rowClickCallBack"
              :updateIsDefault="screenConfig.isDefaultEndPoint"
              v-if="dataLoaded"
              :exportFileName="screenConfig.exportFileName"
              :valueChangeListners="getListners"
              :persistenceKey="persistenceKey"
              :heightPadding="20"
              :paging="false"
              ref="split-view-grid"
              :defaultUserSettings="defaultUserSettings"
            />
          </div>
        </template>

        <template #rightContent>
          <gc-form-header-toolbar
            :toolbar-options="formConfig.headerToolbar"
            :data-model="formModel"
            :backRoute="screenConfig.pageRoute"
            :formLocation="formConfig.headerToolbar.toolbarFormLocation"
            v-if="renderForm"
            :itemSaveCallBack="itemSaveCallBack"
            :baseView="baseView"
          ></gc-form-header-toolbar>

          <div class="view-card responsive-paddings split-view-form">
            <GcForm
              :formOptions="formOptions"
              :formItems="getFormItems"
              :isNormal="true"
              :data-model="formModel"
              v-if="renderForm"
              :formMode="baseView.mode"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'split-view-form'"
              :formLocation="'normal'"
              :formContentReady="formContentReady"
              :formHeight="getFormHeight"
              ref="split-view-form"
            />
          </div>

          <!-- <gc-header-form :header-options="screenConfig.detailsForm"></gc-header-form> -->
        </template>
      </gc-split-view>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { SplitViewService } from "../_services/api/templates/split-view.services";
import { mapGetters } from "vuex";
import { tabAccessControl } from "../_helpers/access-control";

let baseLineBase = {
  RecordId: "00000000-0000-0000-0000-000000000000",
};

export default {
  props: {
    /**
     * contains report configurations
     */
    screenConfig: {
      type: Object,
      default: undefined,
    },
    customMessages: {
      type: Object,
      default: undefined,
    },
    backButtonRoute: {
      type: String,
      default: "/home",
    },
    dataModel: {
      type: [Array, Object],
      default: () => {},
    },
    formConfig: {
      type: Object,
      default: undefined,
    },
    setLoading: {
      type: Boolean,
      default: false,
    },
    validationSummary: {
      type: Array,
      default: () => [],
    },
    defaultPayload: {
      type: Object,
      default: () => {},
    },
    persistenceKey: {
      type: String,
    },
    backButtonEnable: {
      type: Boolean,
      default: true,
    },
    defaultUserSettings: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [RouteMixin, FormMixin],
  components: {},

  data() {
    return {
      //   backButtonRoute: `/reports/${this.$route.params.category}`,
      //   report: {
      //     title: "",
      //     exportFileName: "",
      //     featureCode: "",
      //     dataSourceConfig: null,
      //     columns: [],
      //   },
      dataLoaded: true,
      formOptions: {
        gcLabelLocation: "left",
      },
      formModel: this.dataModel,
      renderForm: false,
      isValid: false,
      formHeight: "auto",
    };
  },
  computed: {
    tabsAccessControl() {
      if (this.screenConfig.tabs)
        return tabAccessControl(this.screenConfig.tabs);
      else return [];
    },
    ...mapGetters({ updateIsDefault: "ui/getUpdateIsDefault" }),
    ...mapGetters({ updateIsDefaultCode: "ui/getUpdateIsDefaultCode" }),
    ...mapGetters({ updateIsDefaultEvent: "ui/getUpdateIsDefaultEvent" }),
    ...mapGetters({ heigthForForm: "ui/getHeigthForForm" }),
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    getFormItems() {
      var items = { ...this.formConfig };
      return [...items.formItems];
    },
    getFormHeight() {
      if (this.formConfig.formHeight) return this.formConfig.formHeight;
      else return "auto";
    },
    getListners() {
      return this.screenConfig.gridData.valueChangedEventListners;
    },
  },

  async created() {
    this.$store.dispatch("ui/headerFormHeight", undefined);
  },
  methods: {
    formContentReady(e) {
      if (e)
        this.formHeight =
          this.heigthForForm -
          document.getElementsByClassName("form-header-toolbar")[0]
            .clientHeight -
          40;
    },
    itemSaveCallBack() {
      // if (this.formModel["IsDefault"])
      if (this.formModel["SetDefault"]) this.formModel["IsDefault"] = "Y";
      else if (this.formModel["SetDefault"] == undefined)
        this.formModel["IsDefault"] = undefined;
      else this.formModel["IsDefault"] = "N";

      this.isValid = true;
    },
    async valueChangeCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        // this.showLoading(true);
        let payload = { ...this.formModel };
        if (payload.SetDefault != undefined) delete payload.SetDefault;
        if (payload.IsDefaultData != undefined) delete payload.IsDefaultData;
        if (payload.IsPostalData != undefined) delete payload.IsPostalData;
        if (payload.ChangedBy != undefined) delete payload.ChangedBy;
        if (payload.CreatedBy != undefined) delete payload.CreatedBy;
        if (payload.DateChanged != undefined) delete payload.DateChanged;
        if (payload.DateCreated != undefined) delete payload.DateCreated;

        var index = this.screenConfig.gridData.columns.findIndex((item) => {
          return item.screenField == "IsDefault";
        });

        if (index == -1) delete payload.IsDefault;

        if (payload.Inactive != undefined) {
          if (this.formModel["Inactive"]) payload.Inactive = "N";
          else payload.Inactive = "Y";
        }

        if (this.formConfig.overWritePayload)
          payload = this.formConfig.overWritePayload(payload);

        if (this.baseView.mode == "edit" && this.screenConfig.updateEndPoint) {
          if (this.screenConfig.updateKeyField) {
            if (this.screenConfig.updateKeyFieldType) {
              await SplitViewService.updateItemByCodeWithType(
                this.screenConfig.updateEndPoint,
                payload[this.screenConfig.updateKeyField],
                payload,
                this.screenConfig.updateKeyFieldType
              )
                .then((res) => {
                  if (res) this.showLoading(false);
                  this.showUpdateSuccessMessage(res);

                  this.setIgnoreRouteChangeConfirmation();
                  this.$router.push({
                    path:
                      this.screenConfig.pageRoute +
                      "/review/" +
                      payload[this.screenConfig.updateKeyField],
                  });
                })
                .catch((err) => {
                  this.$logger.debug("Save item err ", err);
                  this.showLoading(false);
                  this.displayServerError(err, "Item Save Failed");
                });
            } else {
              await SplitViewService.updateItemByCode(
                this.screenConfig.updateEndPoint,
                payload[this.screenConfig.updateKeyField],
                payload
              )
                .then((res) => {
                  if (res) this.showLoading(false);
                  this.showUpdateSuccessMessage(res);

                  this.setIgnoreRouteChangeConfirmation();
                  this.$router.push({
                    path:
                      this.screenConfig.pageRoute +
                      "/review/" +
                      payload[this.screenConfig.updateKeyField],
                  });
                })
                .catch((err) => {
                  this.$logger.debug("Save item err ", err);
                  this.showLoading(false);
                  this.displayServerError(err, "Item Save Failed");
                });
            }
          } else {
            await SplitViewService.updateItem(
              this.screenConfig.updateEndPoint,
              payload.RecordId,
              payload
            )
              .then((res) => {
                if (res) this.showLoading(false);
                let display = res.data.Name
                  ? res.data.Name
                  : res.data.Description
                  ? res.data.Description
                  : "";

                this.$notify(
                  `${
                    this.screenConfig.title + " " + display
                  } saved successfully`,
                  "Success"
                );

                this.setIgnoreRouteChangeConfirmation();
                this.$router.push({
                  path:
                    this.screenConfig.pageRoute + "/review/" + payload.RecordId,
                });
              })
              .catch((err) => {
                this.$logger.debug("Save item err ", err);
                this.showLoading(false);
                this.displayServerError(err, "Item Save Failed");
              });
          }
        } else {
          this.showLoading(true);
          await SplitViewService.saveItem(
            this.screenConfig.saveEndPoint,
            payload
          )
            .then((res) => {
              if (res) this.showLoading(false);

              this.showCreateSuccessMessage(res);

              this.setIgnoreRouteChangeConfirmation();
              this.$router.push({
                path:
                  this.screenConfig.pageRoute +
                  "/review/" +
                  res.data[
                    this.screenConfig.gridData.gridOptions.rowSelect.idProperty
                  ],
              });
            })
            .catch((err) => {
              this.$logger.debug("Save item err ", err);
              this.showLoading(false);
              this.displayServerError(err, "Item Save Failed");
            });
        }
      }

      this.isValid = false;
    },
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    rowClickCallBack(e) {
      if (!e.data || e.column.dataField == "IsDefault") return;

      var items = this.formConfig.formItems.filter((x) => {
        return x.visible == false;
      });
      if (items)
        items.forEach((element) => {
          if (element.hideCondition) element.visible = true;
        });
      this.onRowClicked(e, this.screenConfig.gridData.gridOptions.rowSelect);
      //   this.formModel = e.data;
    },

    async handleLocalRouteChange() {
      this.renderForm = false;
      if (this.screenConfig.title) document.title = this.screenConfig.title;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id
      ) {
        this.showLoading(true);
        this.getRecord();
      } else {
        this.formModel = this.dataModel;
        var index = this.screenConfig.gridData.columns.findIndex((item) => {
          return item.screenField == "IsDefault";
        });

        let getDefault = true;
        if (index != -1) {
          await SplitViewService.getItems({
            url: "api/" + this.screenConfig.recordEndPoint,
            select: "Code,IsDefault",
            filter: "IsDefault eq 'Y'",
            count: true,
          }).then((res) => {
            if (res.data.value.length > 0) getDefault = false;
          });
        }

        for (const property in this.formModel) {
          if (property == "Inactive") this.formModel[property] = true;
          else if (property == "SetDefault")
            this.formModel[property] = getDefault;
          else if (property == "SetAsPostalAddress")
            this.formModel[property] = true;
          else this.formModel[property] = undefined;
        }
        if (this.screenConfig.recordPostProcess) {
          this.formModel = this.screenConfig.recordPostProcess(this.formModel);
        }

        this.renderForm = true;
        this.showLoading(false);
      }

      if (this.$refs["split-view-grid"])
        this.$refs["split-view-grid"].reSizeGrid();
    },

    async getRecord() {
      var filter = undefined;
      if (
        this.screenConfig.gridData.gridOptions.rowSelect.idMode != "Guid" &&
        this.screenConfig.gridData.gridOptions.rowSelect.idMode != "Number"
      )
        filter = `${this.screenConfig.gridData.gridOptions.rowSelect.idProperty} eq '${this.baseView.id}'`;
      else
        filter = `${this.screenConfig.gridData.gridOptions.rowSelect.idProperty} eq ${this.baseView.id}`;

      await SplitViewService.getByCode(this.screenConfig.recordEndPoint, filter)
        .then(async (response) => {
          if (response.data.value.length > 0) {
            var model = await this.crateFormModel();
            if (model) {
              for (var key in model) {
                if (model.hasOwnProperty(key)) {
                  this.formModel[key] = response.data.value[0][key];
                }
              }

              if (response.data.value[0].RecordId)
                this.formModel["RecordId"] = response.data.value[0].RecordId;
              else this.formModel["RecordId"] = baseLineBase.RecordId;

              if (response.data.value[0].IsDefault)
                if (response.data.value[0].IsDefault == "Y")
                  this.formModel["SetDefault"] = this.formModel[
                    "IsDefaultData"
                  ] = true;
                else
                  this.formModel["SetDefault"] = this.formModel[
                    "IsDefaultData"
                  ] = false;

              if (response.data.value[0].Inactive)
                if (response.data.value[0].Inactive == "Y")
                  this.formModel["Inactive"] = false;
                else this.formModel["Inactive"] = true;
            } else this.formModel = response.data.value[0];
          }

          if (this.screenConfig.recordPostProcess) {
            this.formModel = this.screenConfig.recordPostProcess(
              this.formModel
            );
          }
          this.renderForm = true;
          this.showLoading(false);
        })
        .catch((err) => {
          if (err) this.showLoading(false);
        });
    },
    async crateFormModel() {
      this.formConfig.formItems.forEach((element) => {
        element.items.forEach((item) => {
          let dataField = item.dataField ? item.dataField : item.screenField;
          this.formModel[dataField] = undefined;
        });
      });

      return this.formModel;
    },
    showUpdateSuccessMessage(res) {
      this.showGenericSaveSuccessMessage(res);
    },
    showCreateSuccessMessage(res) {
      if (this.customMessages && this.customMessages.success) {
        var message = this.customMessages.success.message;
        this.customMessages.success.keys.forEach((key) => {
          message = message.replace(`<${key}>`, this.formModel[key]);
        });

        this.$notify(message, "Success");
      } else this.showGenericSaveSuccessMessage(res);
    },
    showGenericSaveSuccessMessage(res) {
      let display = res.data.Name
        ? res.data.Name
        : res.data.Description
        ? res.data.Description
        : "";

      this.$notify(
        `${this.screenConfig.title + " " + display} saved successfully`,
        "Success"
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    routeError(val) {
      if (val) this.showLoading(false);
      this.routeError = false;
    },
    async updateIsDefault(val) {
      if (val) {
        this.showLoading(true);
        var payload = this.defaultPayload
          ? this.defaultPayload
          : {
              Code: this.updateIsDefaultCode,
            };
        await SplitViewService.saveItem(
          this.screenConfig.isDefaultEndPoint,
          payload
        )
          .then((res) => {
            if (res) {
              this.$store.dispatch("ui/setUpdateGridOnDefault", true);
              if (
                (this.formModel["IsDefault"] == "Y" ||
                  this.formModel["SetDefault"] ||
                  this.formModel["Code"] == this.updateIsDefaultCode) &&
                (this.baseView.mode == "review" || this.baseView.mode == "edit")
              ) {
                this.renderForm = false;
                this.getRecord();
              } else this.showLoading(false);
            }
          })
          .catch((err) => {
            if (err) this.showLoading(false);

            if (this.updateIsDefaultEvent) {
              this.updateIsDefaultEvent.component.beginUpdate();
              this.updateIsDefaultEvent.component.option("value", false);
              this.updateIsDefaultEvent.component.endUpdate();
            } else this.dataLoaded = false;

            this.displayServerError(err, "Set Default Failed");

            this.$store.dispatch("ui/setUpdateIsDefault", {
              update: false,
              code: undefined,
            });

            setTimeout(() => {
              this.dataLoaded = true;
            }, 200);
          });
      }
    },
    setLoading(val) {
      this.showLoading(val);
    },
    validationSummary: {
      handler(val) {
        if (val.length > 0) {
          this.displayValidationSummary(val);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
// .view-card {
//   // -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
//     // 0 1px 2px rgba(0, 0, 0, 0.24);
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
//   background-color: #fff;
//   margin: 2px 0px 3px;
// }

.responsive-paddings {
  padding: 20px;
}

.dx-scrollview-content .content .view-card.responsive-paddings {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.split-view-template {
  .split-container .left-container {
    margin-right: 0;
    margin-left: 0;
    .dx-card {
      margin-left: 0;
    }
  }
  .split-container-child.right-container {
    margin-left: 0;
  }
}
</style>
